import React from "react";
import { Avatar } from "@sonder/ui/source/styled/components/Avatar";
import { getCreatedAtDescriptionFromDate } from "@sonder/ui/source/styled/components/Comment";
import {
  CommentAuthor,
  CommentContent,
  CommentCreatedAt,
  Comment as CommentFragment,
  CommentGutter,
  CommentHeader,
} from "@sonder/ui/source/styled/fragments/Comment";

interface ActionProps {
  authorId: string;
  authorName: string;
  children: React.ReactNode;
  createdAt: string;
  loggedInUserId: string;
}

export const Action = ({
  authorId,
  authorName,
  children,
  createdAt,
  loggedInUserId,
}: ActionProps) => {
  const isOwnAction = loggedInUserId === authorId;
  return (
    <CommentFragment>
      <CommentGutter>
        <Avatar name={authorName} />
      </CommentGutter>
      <CommentContent>
        <CommentHeader>
          <CommentAuthor>{isOwnAction ? "You" : authorName}</CommentAuthor>
          <CommentCreatedAt>
            {getCreatedAtDescriptionFromDate(createdAt)}
          </CommentCreatedAt>
        </CommentHeader>
        {children}
      </CommentContent>
    </CommentFragment>
  );
};
